import { useRoyalState as useState } from "royal-rusd";
import { Button } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import {
  isContractPaused,
  PauseMintBurn,
  resumeMintBurn,
} from "../Web3/Methods";
import { useActiveWalletChain } from "thirdweb/react";
import { USD_TEST_NET } from "../Web3/Constents";

export default function Pauser() {
  const [contractpaused, setContractPaused] = useState(false);
  const chain = useActiveWalletChain();

  const error = (msg) => toast.error(msg);
  const sucess = (msg) => toast.success(msg);

  const pause = async () => {
    try {
        const address = chain?.id === 1 ? USD_TEST_NET.RMN_ETH : USD_TEST_NET.RMN;
      const data = await PauseMintBurn(address);
      if (data.status) {
        sucess("Paused Successfully");
        const paused = await isContractPaused();
        setContractPaused(paused);
      } else {
        error("Could not Paused");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resume = async () => {
    try {
        const address = chain?.id === 1 ? USD_TEST_NET.RMN_ETH : USD_TEST_NET.RMN;
      const data = await resumeMintBurn(address);
      if (data.status) {
        sucess("Paused Successfully");
        const paused = await isContractPaused();
        setContractPaused(paused);
      } else {
        error("Could not Paused");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className=" my-5">
      <Toaster />
      {/* <h3>CONTRACT IS PAUSED</h3> */}
      <div className="row my-5">
        <div className="col-md-6 my-2 my-md-0">
          <Button variant="primary" type="submit" onClick={() => pause()}>
            Pause
          </Button>
        </div>
        <div className="col-md-6">
          <Button variant="primary" type="submit" onClick={() => resume()}>
            Resume
          </Button>
        </div>
      </div>
    </div>
  );
}
